var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditcardicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_87_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.4583 14.2083V41.7083C55.4583 42.9687 55.0095 44.0477 54.112 44.9453C53.2144 45.8429 52.1354 46.2917 50.875 46.2917H14.2083C12.9479 46.2917 11.8689 45.8429 10.9714 44.9453C10.0738 44.0477 9.625 42.9687 9.625 41.7083V14.2083C9.625 12.9479 10.0738 11.8689 10.9714 10.9714C11.8689 10.0738 12.9479 9.625 14.2083 9.625H50.875C52.1354 9.625 53.2144 10.0738 54.112 10.9714C55.0095 11.8689 55.4583 12.9479 55.4583 14.2083ZM14.2083 18.7917H50.875V14.2083H14.2083V18.7917ZM14.2083 27.9583V41.7083H50.875V27.9583H14.2083Z",
    fill: "#1B4965"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_87_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditcardicon);
export default __webpack_public_path__ + "static/media/creditcardicon.1e00d1ad870fc004bc51c986b9e02af1.svg";
export { ForwardRef as ReactComponent };